import {DDR} from './ddr.class';

export class DDRPregnant18Strategy extends DDR {
  constructor() {
    super([750, 5, 15, 75, 80, 1.4, 1.4, 18, 1.9, 600, 2.6, 6, 30, 450, 1300, 29, 1000, 3, 220, 27, 400, 2, 1250, 60, 13]);
  }
}
